import { Form } from "antd";
import { TopBox } from "components";
import { useOverview } from "providers/overview";
import { useTranslation } from "react-i18next";
import { useGetPropertyDashboardRepairingUnit } from "service/dashboard/property/homecare";
import { LoadingDashboard } from "../..";

const Unit = () => {
  const { t } = useTranslation();
  const { findDate } = useOverview();

  const unitRepairDate = Form.useWatch("unitRepairDate");
  const date = findDate(unitRepairDate);

  const query = useGetPropertyDashboardRepairingUnit({ ...date });

  return (
    <LoadingDashboard loading={query.isFetching}>
      <TopBox
        height={350}
        query={query}
        nameDate="unitRepairDate"
        title={t("top-5-unit-repair")}
        keyTitle="unitNumber"
        text={t("time")}
      />
    </LoadingDashboard>
  );
};

export default Unit;
